var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLetterHeadTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 315,
    height: 71,
    viewBox: "0 0 315 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M314.5 0H197C197 0 213.186 25.1939 227.5 37.5C255.055 61.1889 314.5 70.5 314.5 70.5V0Z",
    fill: "#20283B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153 38C106 38 0 0.5 0 0.5H262C262 0.5 200 38 153 38Z",
    fill: "#20283B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M180 38C133 38 27 0.5 27 0.5H289C289 0.5 227 38 180 38Z",
    fill: "#16A9BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterHeadTop);
export default __webpack_public_path__ + "static/media/LetterHeadTop.40745db660dd21ae559a506513011c7d.svg";
export { ForwardRef as ReactComponent };